import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useMemo } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { CardMenuIcon, ReducedCardMenuIconBox } from '../../../features/cardMenu';
import { getShortContentOverviewUrl, getShortContentUrl, useShort, useShortStatus } from '../../shortContent';
import ReducedCardSkeleton from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardSkeleton';
import ReducedCardLayout from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardLayout';
import PositionedInlineList from '../../../components/ContentCards/ReducedContentCard/subcomponents/PositionedInlineList';
import { ShortCardTimeReadout } from '..';
import { HasGate } from '../../accounts';
import { useLocation } from 'react-router-dom';
import { CardCompletedMessage } from '../../../components/TrackCard/Thumbnail/ThumbnailOverlayed';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReducedShortCard = ({
  shortId,
  use,
  onClick = () => {},
  appearsIn,
  position,
  isSelected,
  language,
  size,
  customAction,
  playlistId,
  overviewType
}) => {
  const {
    short,
    shortLoading
  } = useShort(shortId, language);
  const {
    pathname
  } = useLocation();
  const {
    status,
    allProgressLoading
  } = useShortStatus(shortId, language);
  const handleClick = useCallback(() => {
    onClick();
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'SHORT_FORM_CONTENT',
      shortId,
      appearsIn,
      position,
      name: short && short.name,
      style: 'reduced',
      playlistId
    });
  }, [onClick, shortId, appearsIn, position, short, playlistId]);
  const to = useMemo(() => overviewType ? getShortContentOverviewUrl({
    shortId,
    language,
    playlistId,
    overviewType,
    pathname
  }) : getShortContentUrl({
    shortId,
    language,
    playlistId
  }), [language, overviewType, pathname, playlistId, shortId]);
  if (shortLoading || allProgressLoading) {
    return /*#__PURE__*/_jsx(ReducedCardSkeleton, {
      size: size,
      use: use
    });
  }
  if (!short) {
    return null;
  }
  const {
    name,
    description,
    previewThumbnailSquareUrl
  } = short;
  const isCompleted = status === 'COMPLETED';
  return /*#__PURE__*/_jsx(HasGate, {
    gate: "Academy:ShortFormContent",
    children: /*#__PURE__*/_jsx(ReducedCardLayout, {
      contentId: shortId,
      customAction: customAction,
      description: description,
      isCompleted: isCompleted,
      isSelected: isSelected,
      name: name,
      onClick: handleClick,
      progressAmount: isCompleted ? 1 : 0,
      rightAction: /*#__PURE__*/_jsx(ReducedCardMenuIconBox, {
        className: "m-right-3",
        children: /*#__PURE__*/_jsx(CardMenuIcon, {
          language: language,
          shortId: shortId,
          use: use
        })
      }),
      size: size,
      thumbnailUrl: previewThumbnailSquareUrl || '',
      to: to,
      use: use,
      children: /*#__PURE__*/_jsx(PositionedInlineList, {
        children: isCompleted ? /*#__PURE__*/_jsx(CardCompletedMessage, {
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.shortContent.watched"
          })
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.reducedContentCards.short"
          }), /*#__PURE__*/_jsx(ShortCardTimeReadout, {
            language: language,
            shortId: shortId
          })]
        })
      })
    })
  });
};
export default ReducedShortCard;